import React from "react"
import { createUseStyles } from "react-jss"

const useStyles = createUseStyles({
  errorContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
})

export const CustomErrorMsg = () => {
  const classes = useStyles()

  return <div className={classes.errorContainer}>Something went wrong</div>
}
